import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "collectorContainer" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", {
    class: "grafanaContainer",
    "on:onMouseDown": _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getTimePeriod && _ctx.getTimePeriod(...args)))
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadIframe && _ctx.reloadIframe(...args))),
        class: "btn btn-sm btn-secondary iconButton refreshButton"
      }, [
        _cache[4] || (_cache[4] = _createTextVNode(" Dashboards", -1)),
        _createVNode(_component_vue_feather, {
          type: "grid",
          size: "16"
        })
      ]),
      _createElementVNode("div", null, _toDisplayString(_ctx.errorMessage), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getTimePeriod && _ctx.getTimePeriod(...args))),
        class: "btn btn-sm btn-success iconButton getTimeButton"
      }, [
        _cache[5] || (_cache[5] = _createTextVNode(" Show Bursts", -1)),
        _createVNode(_component_vue_feather, {
          type: "list",
          size: "16"
        })
      ])
    ], 512), [
      [_vShow, _ctx.iframeLoaded]
    ]),
    _withDirectives(_createVNode(_component_LoadingSpinner, null, null, 512), [
      [_vShow, !_ctx.iframeLoaded]
    ]),
    _withDirectives(_createElementVNode("iframe", {
      name: "iframe1",
      id: "iframe1",
      src: _ctx.iframeSrc,
      width: "100%",
      height: "100%",
      frameborder: "0",
      onLoad: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.styleiframe && _ctx.styleiframe(...args)))
    }, null, 40, _hoisted_2), [
      [_vShow, _ctx.iframeLoaded]
    ])
  ], 32))
}